<template>
  <vxe-modal v-model="visible" :title="title" type="confirm" width="75%" @confirm="confirm">
    <template v-if="selectedRows.length > 0">
      <vxe-button icon="vxe-icon-square-close-fill" mode="text" size="mini" status="primary" @click="closeTag()"></vxe-button>
      <template v-for="row in selectedRows">
        <a-tooltip v-if="row.name.length > 10" :key="row.id" :title="row.name">
          <a-tag :key="row.id" :closable="true" @close="() => closeTag(row)" color="blue">
            {{`${row.name.slice(0, 10)}...`}}
          </a-tag>
        </a-tooltip>
        <a-tag v-else :key="row.id" :closable="true" @close="() => closeTag(row)" color="blue">
          {{row.name}}
        </a-tag>
      </template>
      <a-divider/>
    </template>
    <vxe-card>
      <template #title>
        <vxe-select v-model="query['owner.id']" :options="owners" clearable placeholder="business.label.owner" @change="refresh"/>
        <vxe-input v-model="query['no']" clearable placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['name']" clearable placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table
        ref="table"
        :checkbox-config="{trigger: 'row'}"
        :data="data"
        :loading="loading"
        :min-height="500"
        :radio-config="{trigger: 'row'}"
        :row-config="{isCurrent: true, isHover: true ,useKey:true, keyField: 'id'}"
        @checkbox-all="({checked})=>checkAll(checked)"
        @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
        @cell-dblclick="({row})=>dblclick(row)">
        <vxe-column :type="selectType" fixed="left" width="40"/>
        <vxe-column field="no" title="business.label.no"/>
        <vxe-column field="name" title="business.label.name"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:dataSources}" field="dataSource" title="business.label.dataSource"/>
        <vxe-column v-if="query['type.ordinal']>1" :formatter="({row})=>getStrings(row.owners,'name')" field="owners" title="business.label.owner"/>
        <vxe-column field="mnemonicCode" title="business.label.mnemonicCode"/>
        <vxe-column v-if="query['type.ordinal']>1" field="pickupMode.name" title="business.label.pickupMode"/>
        <vxe-column v-if="query['type.ordinal']>1" field="classification.name" title="business.label.classification"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column v-if="query['type.ordinal']===2" :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoAccepting" title="business.label.autoAccepting" width="70"/>
        <vxe-column v-if="query['type.ordinal']===2" :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoPutaway" title="business.label.autoPutaway" width="70"/>
        <vxe-column v-if="query['type.ordinal']===3" :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoPrint" title="business.label.autoPrint" width="70"/>
        <vxe-column v-if="query['type.ordinal']===3" :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="mergeOrder" title="business.label.mergeOrder" width="70"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </vxe-modal>
</template>

<script>
import { findAll } from '@/api/Api'
import { getEnums, getOptions, getStrings } from '@/utils/util'

export default {
  name: 'CustomerModal',
  data() {
    return {
      show: true,
      visible: false,
      loading: false,
      data: [],
      query: { no: '', name: '', 'owner.id': undefined },
      args: null,
      selectedRows: [],
      owners: [],
      dataSources: [],
      record: undefined,
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('DataSource')
    }).then(result => {
      this.dataSources = result
    })
  },
  props: {
    selectType: {
      type: String,
      default: 'radio'
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    getStrings,
    init(args) {
      this.query = { no: '', name: '', 'owner.id': undefined }
      this.data = []
      this.selectedRows = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e, selectedRows) {
      this.init(args)
      this.record = e
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
      this.visible = true
      this.refresh()
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('partyFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.selectedRows.length > 0) {
            this.$refs.table.setCheckboxRow(this.selectedRows, true)
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = { no: '', name: '', 'owner.id': undefined }
      Object.assign(this.query, this.args)
      this.refresh()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        const radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    closeTag(row) {
      if (row) {
        this.$refs.table.setCheckboxRow(row, false)
      } else {
        this.$refs.table.clearCheckboxRow()
      }
      this.removeSelectedRow(row)
    },
    addTag(row) {
      if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
        this.selectedRows.push(row)
      }
    },
    removeSelectedRow(row) {
      if (row) {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
      } else {
        this.selectedRows = []
      }
    },
    changeCheckbox(checked, row) {
      if (this.selectType === 'radio') {
        return
      }
      if (checked) {
        this.addTag(row)
      } else {
        this.removeSelectedRow(row)
      }
    },
    checkAll(checked) {
      this.data.forEach(item => {
        if (checked) {
          this.addTag(item)
        } else {
          this.closeTag(item)
        }
      })
    }
  }
}
</script>